'use strict';

var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined'

if (!isNode) {
    var respimage = require('respimage');

    // Breaks overlay chat icon because height is set in CSS (to 27px) but width is not also set;
    // icon.png is larger and is stretched in IE11
    // see https://github.com/greenpeace/ggw_styleguide/tree/master/source/libraries/respimage/plugins/intrinsic-dimension
    // require('respimage/plugins/intrinsic-dimension/ri.intrinsic.js');
}

var Constants = require('../constants');

const base64 = {}
for (const type of ['light', 'mid', 'simple', 'solid'])
    for (const dir of ['left', 'up', 'right', 'down'])
        try {
            base64['moma/nav-'+type+'-'+dir] = require('../../../server/public/static/images/moma/nav-'+type+'-'+dir+'.png')
            base64['moma/nav-'+type+'-'+dir+'@2x'] = require('../../../server/public/static/images/moma/nav-'+type+'-'+dir+'@2x.png')
        } catch (e) {}
base64['collections/zoom.png'] = require('../../../server/public/static/images/collection/zoom.png')

var DeviceImage = React.createClass({
    propTypes: {
        // Image src - "@2x" will be inserted before the extension
        src: React.PropTypes.string.isRequired,

        // Optional alt text
        alt: React.PropTypes.string,

        // Optional class names
        className: React.PropTypes.string,
        
        // Optional size attributes
        width: React.PropTypes.string,
        height: React.PropTypes.string,

        // Optional base64 boolean
        base64: React.PropTypes.bool
    },

    render: function() {
        // replace terminating .png with @2x.png (where .png can be any 3-letter extension)
        const x2src = this.props.src.replace(/\.\w{3}$/, '@2x$&')
        const x1path = `${Payload.static}/images/${this.props.src}`
        const x2path = `${Payload.static}/images/${x2src}`
        const x1webp = `${Payload.webp}/images/${this.props.src}.webp`
        const x2webp = `${Payload.webp}/images/${x2src}.webp`
        const x1img = (this.props.base64 && base64[this.props.src]) || x1path
        const x2img = (this.props.base64 && base64[x2src]) || x2path
        const x1imgWebp = (this.props.base64 && base64[this.props.src]) || x1webp
        const x2imgWebp = (this.props.base64 && base64[x2src]) || x2webp

        return (
            <picture>
                <source srcSet={`${x1imgWebp} 1x, ${x2imgWebp} 2x`} />
                <source srcSet={`${x1img} 1x, ${x2img} 2x`} />
                <img 
                    srcSet={`${x1img} 1x, ${x2img} 2x`} 
                    src={x1img} 
                    width={this.props.width} 
                    height={this.props.height} 
                    alt={this.props.alt} 
                    className={this.props.className} />
            </picture>
        )
    },
})

module.exports = DeviceImage



// WEBPACK FOOTER //
// ./src/global/device-image.jsx